import { render } from "./statisticsModal.vue?vue&type=template&id=36adef64&scoped=true"
import script from "./statisticsModal.vue?vue&type=script&lang=js"
export * from "./statisticsModal.vue?vue&type=script&lang=js"

import "./statisticsModal.vue?vue&type=style&index=0&id=36adef64&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36adef64"

export default script